<template>
<svg fill="none" height="20" viewBox="0 0 24 24" width="18" xmlns="http://www.w3.org/2000/svg"><g stroke="#AFB5C2" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m1 12s4-8 11-8 11 8 11 8"/><path d="m1 12s4 8 11 8 11-8 11-8"/><circle cx="12" cy="12" r="3"/></g></svg>

</template>
